import { BdState } from '@bindoc-projects/geographic-domain-lib';
import { BdMapsStateSelectHandler } from './select-handler';
import { BdMapsStateSelectOptions } from './select-options';

export class BdMapsStateSelectMultipleHandler extends BdMapsStateSelectHandler<
  BdState[]
> {
  private _initialStateIds: number[];

  public selectedAllStates = false;

  constructor() {
    super();
  }

  public toggleSelectAll(select: boolean) {
    const newSelection = select ? this.states : [];

    this.updateSelection(newSelection);
  }

  public selectById(stateIds: number[]): void {
    if (!this._states) {
      return;
    }

    const filtered: BdState[] = this._states.filter((it) =>
      stateIds.includes(it.id),
    );

    if (!!filtered && filtered.length > 0) {
      this.updateSelection(filtered);
    }
  }

  get initialStateIds(): number[] {
    return this._initialStateIds;
  }

  set initialStateIds(value: number[]) {
    this._initialStateIds = value;

    this.selectById(value);
  }

  get states(): BdState[] {
    return this._states;
  }

  set states(value: BdState[]) {
    this._states = value.sort((a, b) => {
      if (!a || !b) {
        return !a ? 1 : -1;
      }

      return a.name.localeCompare(b.name);
    });
    this.statesOptions = this._states;
    this.selectedResources = null;

    if (this._initialStateIds) {
      this.selectById(this._initialStateIds);
    }
  }

  set options(options: BdMapsStateSelectOptions) {
    this._options = options;
    this.states = this._getStateOptions(this.states, this._options.includeBund);
  }

  updateSelection(selection: BdState[]): void {
    this.selectedResources = selection ?? [];
    this.selectedAllStates =
      this.selectedResources.length === this.states.length;

    this.statesSelect$.next(this.selectedResources);
  }
}
